import { WORD_CLOUD_CONSTANTS } from '@core/constants/push-live.constants';

export function normalizeWordCloudPhrase(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function countWordCloudWords(value: string): number {
  const phrase = normalizeWordCloudPhrase(value);
  return phrase ? phrase.split(' ').length : 0;
}

export function isValidWordCloudPhrase(value: string): boolean {
  const phrase = normalizeWordCloudPhrase(value);
  return (
    phrase.length > 0 &&
    phrase.length <= WORD_CLOUD_CONSTANTS.MAX_LENGTH &&
    phrase.split(' ').length <= WORD_CLOUD_CONSTANTS.MAX_WORDS
  );
}

// Mirrors the backend grouping: lowercase, and punctuation around each word ignored ("Teamwork." -> "teamwork").
export function normalizeWordCloudTerm(value: string): string {
  return normalizeWordCloudPhrase(value)
    .toLowerCase()
    .split(' ')
    .map((word) => word.replace(/^\p{P}+|\p{P}+$/gu, ''))
    .filter(Boolean)
    .join(' ');
}
